
import { FilterTypes } from '@shared/flight-itinerary/entities/filters';
import { AirResultPackagesPayload } from '@packages/packages-result/entities/air-results';
import { PickedRange, RangePicketVm } from '@shared/filters/entities/fetch-filters.response';
import { TripTypes } from '@app/entities/trip-types';
import { AirportsFilter } from '@flight-results/entities/request-search.payload';
import { isNullOrUndefined } from '@app/util/util';
import { mapFiltersReduce } from '@app/mappers/filters.mapper';
import { AirFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';
import { stringTimeToSeconds } from '@flight-results/mappers/filters.mapper';

export function defaultPackageAirPagination(
  isMobile: boolean): { ResultCountLowerBound: number, ResultCountUpperBound: number } {
  return {
    ResultCountLowerBound: 0,
    ResultCountUpperBound: isMobile ? 60 : 20,
  };
}

export function pickedFlightPackageCheckboxes(searchPayload: AirResultPackagesPayload): string[] {
  return Object.keys(searchPayload).length === 0 ? [] :
    (searchPayload.Stops || []).concat(
      (searchPayload.Alliances || [])).concat(
      (searchPayload.Airlines || [])).concat(
      searchPayload.BusClass || []).concat(
      searchPayload.Tags || []);
}

export function pickedPackageFlightRanges(searchPayload: AirResultPackagesPayload): PickedRange {
  return Object.keys(searchPayload).length === 0 ? {} as PickedRange :
    isNullOrUndefined(searchPayload.PriceFrom) && isNullOrUndefined(searchPayload.PriceTo) ? {
      [FilterTypes.SectorDurations]: pickedPackageFlightDurationsRanges(searchPayload, FilterTypes.SectorDurations),
      [FilterTypes.DepartureTimes]: pickedPackageFlightDurationsRanges(searchPayload, FilterTypes.DepartureTimes)
    } :
      {
        [FilterTypes.PriceRange]: [searchPayload.PriceFrom, searchPayload.PriceTo],
        [FilterTypes.SectorDurations]: pickedPackageFlightDurationsRanges(searchPayload, FilterTypes.SectorDurations),
        [FilterTypes.DepartureTimes]: pickedPackageFlightDurationsRanges(searchPayload, FilterTypes.DepartureTimes)
      };
}

export function pickedPackageFlightDurationsRanges(searchPayload: AirResultPackagesPayload, type: FilterTypes): RangePicketVm {
  const departureRange = searchPayload[type] ? searchPayload[type].find(sector =>
    sector.SectorNumber === TripTypes.DEPARTURE) : null;
  const returnRange = searchPayload[type] ? searchPayload[type].find(sector =>
    sector.SectorNumber === TripTypes.RETURN) : null;
  return {
    [TripTypes.DEPARTURE]: !isNullOrUndefined(departureRange) ?
      [stringTimeToSeconds(departureRange.From), stringTimeToSeconds(departureRange.To)] : [],
    [TripTypes.RETURN]: !isNullOrUndefined(returnRange) ?
      [stringTimeToSeconds(returnRange.From), stringTimeToSeconds(returnRange.To)] : []
  };
}

export function pickedPackageFlightAirportCheckboxes(searchPayload: AirResultPackagesPayload): AirportsFilter {
  return {
    DepartureAirports: searchPayload[FilterTypes.DepartureAirports] || [],
    ArrivalAirports: searchPayload[FilterTypes.ArrivalAirports] || []
  };
}

export function mapFiltersSearchFlightsPackage(filters: AirFiltersResponse, resultsCounts: number): AirFiltersResponse {
  return mapFiltersReduce(filters, resultsCounts) as AirFiltersResponse;
}
